import _, {templateSettings} from 'lodash';
import {RouteService} from "../../services/routeService";
import {NotificationService} from "../../services/notificationService";
import {DICTIONARY} from "../../dictionary";
import {Component} from "@angular/core";
import util from "util";


@Component({
	selector: 'apply-policy-component',
	templateUrl: './apply-policy.component.html',
})
export class ApplyPolicyComponent {
    constructor(private rs:RouteService,
				private ns:NotificationService){
    }

    dic = DICTIONARY;
    adminSelectionType = {all: 'all', managed: 'managed', specific: 'specific'};
    installPolicyInProcess;
    planAdmins;
	fromAdmins;
    adminSelectionTypeSelection;
    installPolicyData;
	planPolicyTemplates = [];
    showApplyPolicyPopup;
    searchAdminTxt;
	_=_;

	selectedPolicyTemplate;
	policiesTemplateInput;


    installPolicy = (data) => {
        this.installPolicyInProcess = false;
		this.selectedPolicyTemplate = null;
		this.policiesTemplateInput = null;
        this.planAdmins = [];
		this.fromAdmins = [];
        data.planAdmins.forEach((adminObj) => {
			// partners assign company names to their plans - prefer it over the admin user's display name ("domain.com Admin")
			const displayName = adminObj.company_name || adminObj.alloc_plan_id?.company_name || adminObj.user_id?.name;
			this.planAdmins.push({email: adminObj.email, name: displayName, enabled: false, isTemplate: adminObj.isTemplate});
			this.fromAdmins.push({email: adminObj.email, name: displayName, enabled: false, isTemplate: adminObj.isTemplate, selected: adminObj.email === data.controlAdmin.email, isAlwaysOnTop: adminObj.email === data.controlAdmin.email ? 2 : null});
        });

        this.adminSelectionTypeSelection = this.adminSelectionType.specific;

        this.installPolicyData = {
            step: this.dic.CONSTANTS.installPolicySteps.selectFromAdmin,
            fromAdmin: data.controlAdmin.email,
            admins: [],
			appendMode: true,
            policy: {
                inbound: {
                    rules: false,
                    inbound_email_rules: false,
					phishing_bypass: false,
					url_rewrite: false,
					url_tracking: false,
					smart_banner: false,
					senders_whitelist: false,
					senders_whitelist_advanced: false,
					personal_list_settings: false,
					senders_blacklist: false,
					links_whitelist: false,
					links_blacklist: false,
					attachments_whitelist: false,
					attachments_blacklist: false,
					block_files_types: false,
					block_files_types_extensions: false
                },
                outbound: {
                    rules: false,
                    policy: false,
					enforce_domain: false,
					outbound_reviewers_quarantine_notifications: false,
					welcome_email: false
                },
				accountTakeover: {
					incident_types: false,
					rules: false,
				},
				domainProtection: {
					domain_impersonation_enabled: false
				},
				threatSimulation: {
					templates: false,
					materials: false,
				}
            }
        };

        this.showApplyPolicyPopup = true;

		this.rs.getInstallPolicies().then((response) => {
			this.planPolicyTemplates = response || [];
		});
    };

    installPolicyExecute = () => {
        if (this.installPolicyInProcess) {
            return;
        }

        this.installPolicyInProcess = true;

		const installPolicyInfo: any = {
			action: 'install',
			type: this.adminSelectionTypeSelection,
			fromAdmin: this.installPolicyData.fromAdmin,
			admins: this.installPolicyData.admins,
			policy: this.installPolicyData.policy
		};

		if (this.installPolicyData.appendMode) {
			installPolicyInfo.append = true;
		}

        this.rs.installPolicy(installPolicyInfo).then((response) => {
            this.ns.showInfoMessage('Policy installation started successfully');
            this.showApplyPolicyPopup = false;
            this.installPolicyInProcess = false;
        }, (err) => {
            this.installPolicyInProcess = false;
        });
    }

    chooseInstallPolicyAdmins = () => {
        this.installPolicyData.admins = this.planAdmins.filter(itm => itm.selected).map(itm => itm.email);
    };

    checkPolicySelected = () => {
        return (this.installPolicyData.policy.inbound.inbound_email_rules ||
			this.installPolicyData.policy.inbound.phishing_bypass ||
			this.installPolicyData.policy.inbound.url_rewrite ||
			this.installPolicyData.policy.inbound.url_tracking ||
			this.installPolicyData.policy.inbound.smart_banner ||
			this.installPolicyData.policy.inbound.rules ||
            this.installPolicyData.policy.inbound.senders_whitelist ||
            this.installPolicyData.policy.inbound.senders_blacklist ||
            this.installPolicyData.policy.inbound.links_whitelist ||
            this.installPolicyData.policy.inbound.links_blacklist ||
            this.installPolicyData.policy.inbound.attachments_whitelist ||
            this.installPolicyData.policy.inbound.attachments_blacklist ||
            this.installPolicyData.policy.inbound.block_files_types ||
            this.installPolicyData.policy.inbound.block_files_types_extensions ||
			this.installPolicyData.policy.inbound.senders_whitelist_advanced ||
			this.installPolicyData.policy.inbound.personal_list_settings ||
			this.installPolicyData.policy.outbound.policy ||
			this.installPolicyData.policy.outbound.enforce_domain ||
			this.installPolicyData.policy.outbound.welcome_email ||
			this.installPolicyData.policy.outbound.outbound_reviewers_quarantine_notifications ||
			this.installPolicyData.policy.outbound.rules ||
			this.installPolicyData.policy.accountTakeover.incident_types ||
			this.installPolicyData.policy.accountTakeover.rules ||
			this.installPolicyData.policy.domainProtection.domain_impersonation_enabled ||
			this.installPolicyData.policy.threatSimulation.templates ||
			this.installPolicyData.policy.threatSimulation.materials);
    }

    installPolicyNextStep = () => {
        this.installPolicyData.error = '';

		switch (this.installPolicyData.step) {
			case this.dic.CONSTANTS.installPolicySteps.selectFromAdmin:
				this.installPolicyData.fromAdmin = this.fromAdmins.find(itm => itm.selected)?.email;
				if (!this.installPolicyData.fromAdmin) {
					this.installPolicyData.error = 'You must select admin';
					return;
				}
				this.installPolicyData.step = this.dic.CONSTANTS.installPolicySteps.selectAdmins;
				break;

			case this.dic.CONSTANTS.installPolicySteps.selectAdmins:
            if (this.adminSelectionTypeSelection === this.adminSelectionType.specific && !this.installPolicyData.admins.length) {
                this.installPolicyData.error = 'You must select at least one admin';
                return;
            }
            this.installPolicyData.step = this.dic.CONSTANTS.installPolicySteps.selectPolicy;
				break;

			case this.dic.CONSTANTS.installPolicySteps.selectPolicy:
            if (!this.checkPolicySelected()) {
                this.installPolicyData.error = 'You must select at least one policy';
                return;
            }
            this.installPolicyData.step = this.dic.CONSTANTS.installPolicySteps.summary;
				break;
        }
    };

    installPolicyBackStep = () => {
        this.installPolicyData.error = '';
        this.searchAdminTxt = '';

		switch (this.installPolicyData.step) {
			case this.dic.CONSTANTS.installPolicySteps.selectAdmins:
				this.installPolicyData.step = this.dic.CONSTANTS.installPolicySteps.selectFromAdmin;
				break;

			case this.dic.CONSTANTS.installPolicySteps.selectPolicy:
            this.installPolicyData.step = this.dic.CONSTANTS.installPolicySteps.selectAdmins;
				break;

			case this.dic.CONSTANTS.installPolicySteps.summary:
            this.installPolicyData.step = this.dic.CONSTANTS.installPolicySteps.selectPolicy;
				break;
        }
    };

    searchToAdmin = (searchTerm, activeFilters) => {
        this.planAdmins.forEach(record => {
            // search
            if (searchTerm) {
                const isFound = this.searchAdminTextExecute(record, searchTerm);
                if (!isFound) {
                    record.hide = true;
                    return;
                }
            }

            record.hide = false;
        });
    };

	searchFromAdmin = (searchTerm, activeFilters) => {
		this.fromAdmins.forEach(record => {
			// search
			if (searchTerm) {
				const isFound = this.searchAdminTextExecute(record, searchTerm);
				if (!isFound) {
					record.hide = true;
					return;
				}
			}

			record.hide = false;
		});
	};

	fromAdminSelection = (adminObj) => {
		this.fromAdmins.forEach(record => {
			if (record.email !== adminObj.email) {
				record.selected = false;
			}
		});
	}

    searchAdminTextExecute = (admin, searchTerm) => {
        searchTerm = searchTerm.toLowerCase();
        return ((admin.name?.toLowerCase().indexOf(searchTerm) > -1) ||
            (admin.email?.toLowerCase().indexOf(searchTerm) > -1));
    }

	selectPolicyTemplate = (policyObj) => {
		this.selectedPolicyTemplate = policyObj;

		Object.keys(policyObj).forEach((categoryKey) => {
			if (this.installPolicyData.policy[categoryKey]) {
				Object.keys(this.installPolicyData.policy[categoryKey] || {}).forEach((modelKey) => {
					this.installPolicyData.policy[categoryKey][modelKey] = !!policyObj[categoryKey][modelKey];
				});
			}
		});
	}

	selectAllPolicies = () => {
		// toggle all - deselect if all are selected, otherwise select all
		const isAllSelected = Object.keys(this.installPolicyData.policy).every((categoryKey) => {
			return Object.keys(this.installPolicyData.policy[categoryKey] || {}).every((modelKey) => {
				return this.installPolicyData.policy[categoryKey][modelKey];
			});
		});
		Object.keys(this.installPolicyData.policy).forEach((categoryKey) => {
			Object.keys(this.installPolicyData.policy[categoryKey] || {}).forEach((modelKey) => {
				this.installPolicyData.policy[categoryKey][modelKey] = !isAllSelected;
			});
		});
	}

	savePolicyInstallTemplate = () => {
		if (this.installPolicyInProcess) {
			return;
		}

		if (!this.checkPolicySelected()) {
			this.installPolicyData.error = util.format(this.dic.ERRORS.selectAtLeastOneX, 'policy');
			return;
		}

		this.policiesTemplateInput.name = this.policiesTemplateInput.name?.trim();

		const isExist = this.planPolicyTemplates.find(template => template.name === this.policiesTemplateInput.name);
		if (isExist) {
			this.updatePolicyInstallTemplate();
			return;
		}
		else {
			const installPolicyInfo = {
				name: this.policiesTemplateInput.name.trim(),
				configuration: this.installPolicyData.policy
			};

			this.installPolicyInProcess = true;
			this.rs.createInstallPolicyTemplate(installPolicyInfo).then((response) => {
				this.ns.showInfoMessage('Save policy template completed successfully');
				this.planPolicyTemplates.push({
					name: installPolicyInfo.name,
					..._.cloneDeep(this.installPolicyData.policy),
				});

				this.selectedPolicyTemplate = this.planPolicyTemplates.find(template => template.name === installPolicyInfo.name);
				this.policiesTemplateInput = null;
				this.installPolicyInProcess = false;
			}, (err) => {
				this.installPolicyInProcess = false;
			});
		}
	}

	updatePolicyInstallTemplate = () => {
		const templateToChange = this.planPolicyTemplates.find(template => template.name === this.policiesTemplateInput.name);

		const installPolicyInfo = {
			action: 'configuration',
			name: this.policiesTemplateInput.name.trim(),
			...this.installPolicyData.policy
		};

		this.installPolicyInProcess = true;
		this.rs.updateInstallPolicyTemplate(installPolicyInfo, templateToChange.name).then((response) => {
			this.ns.showInfoMessage('Update policy template completed successfully');

			Object.keys(this.installPolicyData.policy).forEach((categoryKey) => {
				if (templateToChange[categoryKey]) {
					Object.keys(templateToChange[categoryKey] || {}).forEach((modelKey) => {
						templateToChange[categoryKey][modelKey] = !!this.installPolicyData.policy[categoryKey][modelKey];
					});
				}
			});

			this.policiesTemplateInput = null;
			this.installPolicyInProcess = false;
		}, (err) => {
			this.installPolicyInProcess = false;
		});
	}

	deletePolicyInstallTemplate = (templateObj) => {
		if (this.installPolicyInProcess) {
			return;
		}

		this.installPolicyInProcess = true;
		this.rs.deleteInstallPolicyTemplate(templateObj.name.trim()).then((response) => {
			this.ns.showInfoMessage('Delete policy template completed successfully');
			_.remove(this.planPolicyTemplates, {name: templateObj.name});

			if (this.selectedPolicyTemplate?.name === templateObj.name) {
				this.selectedPolicyTemplate = null;
			}
			this.installPolicyInProcess = false;
		}, (err) => {
			this.installPolicyInProcess = false;
		});
	}

	protected readonly templateSettings = templateSettings;
}
